var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-selector"},[_c('div',{staticClass:"platform-buttons"},_vm._l((_vm.platforms),function(platform,index){return _c('button',{key:index,class:{ selected: _vm.selectedPlatform === platform.value },on:{"click":function($event){return _vm.handleChange(platform.value)}}},[_vm._v(" "+_vm._s(platform.text)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }